import React from 'react';
import { DrawerBody, DrawerFooter } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { briefCreationClickAction } from '../../monitoring/bqEvents';
import { AppI18n } from '../../i18n';
import { ComingSoonImage } from './ComingSoonImage';

export const ComingSoonStep = () => {
  const { setIsOpen, currentStep, contextId, source, variant, parentElement } = useBriefCreationContext();

  return (
    <>
      <DrawerBody>
        <Stack direction="column" gap="2" alignItems="center" justifyContent="center" height="100%">
          <ComingSoonImage />
          <Stack direction="column" gap="2" alignItems="center" width="70%" textAlign="center">
            <Heading size="h_md">
              <AppI18n k="coming_soon_step.title" />
            </Heading>
            <Text color="bodySecondary">
              <AppI18n k="coming_soon_step.description" />
            </Text>
          </Stack>
        </Stack>
      </DrawerBody>
      <DrawerFooter>
        <Stack direction="row" justifyContent="flexEnd">
          <Button
            onClick={() => {
              briefCreationClickAction({
                step: currentStep,
                action: 'got_it',
                briefContextId: contextId,
                eventSource: source || '',
                variant,
                parentElement,
              });

              return setIsOpen(false);
            }}
          >
            <AppI18n k="coming_soon_step.got_it" />
          </Button>
        </Stack>
      </DrawerFooter>
    </>
  );
};
